import { MessageSquare } from "lucide-react";
import { RolePill, fmtAgo } from "./visitorMeta";
import NoteCell from "./NoteCell";

export default function VisitorRow({
    visitor,
    isEditing,
    isSaving,
    draftNote,
    setDraftNote,
    onOpenNote,
    onSaveNote,
    onCancelNote,
}) {
    const shortId = visitor.session_id?.slice(0, 8) || "unknown";
    return (
        <tr
            className="border-t border-[#E5DFD3] hover:bg-[#FAF8F2] align-top"
            data-testid={`visitor-row-${shortId}`}
        >
            <td className="px-5 py-3.5">
                <div className="flex items-center gap-3 min-w-0">
                    <span className="h-8 w-8 rounded-full bg-[#EFEBE0] text-[#0E2A47] grid place-items-center font-semibold text-[12px] shrink-0">
                        {visitor.name ? visitor.name.charAt(0).toUpperCase() : "?"}
                    </span>
                    <div className="min-w-0">
                        <p className="font-medium text-[14px] text-[#1A2230] truncate">
                            {visitor.name || <span className="text-[#6F6B63] italic">Anonymous</span>}
                        </p>
                        <p className="text-[11.5px] text-[#6F6B63] truncate">
                            First seen {fmtAgo(visitor.first_seen)}
                        </p>
                    </div>
                </div>
            </td>
            <td className="px-5 py-3.5">
                <RolePill role={visitor.role} />
            </td>
            <td className="px-5 py-3.5 hidden md:table-cell">
                <span className="inline-flex items-center gap-1.5 text-[#1A2230]">
                    <MessageSquare className="h-3.5 w-3.5 text-[#6F6B63]" />
                    {visitor.message_count || 0}
                </span>
            </td>
            <td className="px-5 py-3.5 text-[#6F6B63] whitespace-nowrap">
                {fmtAgo(visitor.last_seen)}
            </td>
            <td className="px-5 py-3.5 max-w-[340px]">
                <NoteCell
                    visitor={visitor}
                    isEditing={isEditing}
                    isSaving={isSaving}
                    draftNote={draftNote}
                    setDraftNote={setDraftNote}
                    onOpen={onOpenNote}
                    onSave={onSaveNote}
                    onCancel={onCancelNote}
                />
            </td>
        </tr>
    );
}
